import { cn } from "@utils/tw"
import { ComponentPropsWithoutRef, ElementType, forwardRef } from "react"
import { TYPE_CLASS, TypeVariant } from "./typeVariant"

type HeadingProps = ComponentPropsWithoutRef<"h3"> & {
  as?: ElementType
  variant?: TypeVariant
}

export const Heading = forwardRef<HTMLElement, HeadingProps>(
  ({ as: Comp = "h3", variant, className, ...props }: any, ref) => (
    <Comp ref={ref} className={cn("m-0", variant && TYPE_CLASS[variant], className)} {...props} />
  ),
)
Heading.displayName = "Heading"
